exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modalChangeTotalEmployee .error-msg{font-size:12px;color:#e74a4e;text-align:left;display:block}#modalChangeTotalEmployee .modal-header{padding:15px 15px 0;border-bottom:none}#modalChangeTotalEmployee .modal-body{padding-left:80px;padding-right:80px;margin-top:20px;margin-bottom:20px}#modalChangeTotalEmployee .title-modal{text-align:center;padding-top:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase}#modalChangeTotalEmployee .modal-footer .close-btn{background-color:#8b8787}#modalChangeTotalEmployee .modal-footer .btn-register,#modalChangeTotalEmployee .modal-footer .close-btn{border-radius:4px!important;padding:7px 35px;font-weight:600;text-align:center;color:#fff;border:none;height:36px}#modalChangeTotalEmployee .modal-footer .btn-register{background-color:#3598dc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40598755","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/modals/modalChangeTotalEmployee.vue
// module id = 963
// module chunks = 0